const contentEngine = [
	{
		path: '/community/content-engine',
		name: 'community-content-engine',
		component: () => import('@/views/community/content-engine/content-feed.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/content-engine/articles-queue',
		name: 'community-content-engine-articles-queue',
		component: () => import('@/views/community/content-engine/articles-queue.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/content-engine/feeds',
		name: 'community-content-engine-feeds',
		component: () => import('@/views/community/content-engine/feeds.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/content-engine/settings',
		name: 'community-content-engine-settings',
		component: () => import('@/views/community/content-engine/settings.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
]

export default contentEngine
